import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import React, { Component } from "react";
import styled from "styled-components";
import { Box } from "@origin-digital/layout";
import { Accordion, AlertBox } from "@origin-digital/style-guide";
import { Footer } from "../components/Footer";
import { BulletedList } from "../components/BulletedList";
import { slideInAnimation } from "../components/CommonStyles";
export var CollapsibleContainer = styled.div.withConfig({
  displayName: "CollapsibleNBA__CollapsibleContainer",
  componentId: "qeipxs-0"
})(["[data-id=\"accordion\"]{padding-left:32px;padding-right:32px;}[data-id=\"accordion-container\"]{border-bottom:none;}.open{padding-bottom:32px;margin-bottom:0;}", ";"], slideInAnimation);
export var CollapsibleNBA =
/*#__PURE__*/
function (_Component) {
  _inherits(CollapsibleNBA, _Component);

  function CollapsibleNBA() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CollapsibleNBA);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollapsibleNBA)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      successMessage: false
    });

    _defineProperty(_assertThisInitialized(_this), "showSuccessMessage", function () {
      return _this.setState({
        successMessage: true
      });
    });

    return _this;
  }

  _createClass(CollapsibleNBA, [{
    key: "render",
    value: function render() {
      var successMessage = this.state.successMessage;
      var content = this.props.content;

      if (successMessage) {
        return React.createElement(AlertBox, {
          type: "success",
          message: content.successMessage
        });
      }

      return React.createElement(CollapsibleContainer, null, React.createElement(Accordion, {
        label: content.heading
      }, React.createElement(Box, {
        paddingX: 8,
        display: "flex",
        direction: "column",
        width: "100%",
        height: "100%"
      }, React.createElement(BulletedList, {
        content: content
      }), React.createElement(Footer, _extends({}, this.props, {
        onSuccess: this.showSuccessMessage
      })))));
    }
  }]);

  return CollapsibleNBA;
}(Component);